import { Component, inject } from '@angular/core';
import { FirestoreService } from '@services/firestore/firestore.service';
import { IConfiguracionesTexto } from '@interfaces/reforma-configuraciones-texto.interface';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-ampliacion-seguro-lagunas',
    templateUrl: './ampliacion-seguro-lagunas.component.html',
    styleUrl: './ampliacion-seguro-lagunas.component.scss',
    standalone: false
})
export class AmpliacionSeguroLagunasComponent {

  private readonly firestoreService = inject(FirestoreService);

  content$: Observable<IConfiguracionesTexto> = this.firestoreService
    .getDoc<IConfiguracionesTexto>('reforma-pensiones', 'configuraciones-texto');

}